export default __webpack_public_path__ + "static/media/Circly_List_Insertion_1.1cff2a19.gif";